export const CONFIG = require("../config.json");
export const GOOD_FEELINGS_DELAY = 750;

export const TestStates = {
  SUCCESS: "success",
  FAIL: "fail",
  LOADING: "loading",
  NONE: "none",
};

export const Protocols = {
  REST: "rest",
  GRPC: "grpc",
  WEBSOCKET: "websocket",
};
